import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M18.8332 9.62498L7.90539 3.36482C6.06578 2.32146 3.78687 3.63939 3.78687 5.75357V18.2464C3.78687 20.3606 6.06578 21.6785 7.90539 20.6352L18.8332 14.375C20.6729 13.3317 20.6729 10.6683 18.8332 9.62498Z' />
        </SvgIcon>
    );
});
